import Vue from "vue";
import VueGtm from "@gtm-support/vue2-gtm";
import * as _ from "lodash-es";
import router from "../router";

const environment = BACKEND.env;

export default function (config) {
    if (environment == "master" && !_.isEmpty(config.equalweb_sitekey) && !_.isEmpty(BACKEND.nonce)) {
        window.interdeal = {
            "sitekey": config.equalweb_sitekey,
            "Position": "left",
            "domains": {
                "js": "https://cdn.equalweb.com/",
                "acc": "https://access.equalweb.com/"
            },
            "nonce" : BACKEND.nonce,
            "Menulang": "PT",
            "showTooltip": true,
            "btnStyle": {
                "vPosition": [
                    "20%",
                    "80%"
                ],
                "scale": [
                    "0.5",
                    "0.5"
                ],
                "color": {
                    "main": "#386097",
                    "second": "#ffffff"
                },
                "icon": {
                    "outline": true,
                    "type": 1,
                    "shape": "circle"
                }
            }
        };
        (function(doc, head, body){
            var coreCall             = doc.createElement('script');
            coreCall.src             = interdeal.domains.js + 'core/5.1.2/accessibility.js';
            coreCall.defer           = true;
            coreCall.integrity       = 'sha512-PUyQFF3HFjRiVfjOiFFu+RTc0nGmLV5FN3CVw8zWFK6pVbWPAEKy9X2bTUn10GNu1EbxN56MuWu0P8ZHC6xv3Q==';
            coreCall.crossOrigin     = 'anonymous';
            coreCall.setAttribute('nonce', BACKEND.nonce);
            coreCall.setAttribute('data-cfasync', true );
            body? body.appendChild(coreCall) : head.appendChild(coreCall);
        })(document, document.head, document.body);
    } else if (environment == "local" || environment == "develop") {

    }
}
